<template>
  <div class="budget-schedule campaign-step">
    <div class="step-header">
      <div class="step-icon">
        <img src="/images/calendar-coin.svg" alt="budget and schedule" />
      </div>
      <h2>{{ $t('messages.budget_schedule') }}</h2>
    </div>

    <div class="settings-content">
      <!-- Валюта -->
      <Currency :currency="localData.currency" :currencies="currencies" :locked="true" @update="updateCurrency" />

      <!-- Расписание показа -->
      <SchedulePeriods :initial-schedules="localData.schedule" :currency="localData.currency" :currencies="currencies"
        :adGroupStart="adGroupStart" :adGroupEnd="adGroupEnd" :kpi="kpi" :priceValue="priceValue"
        :is-test="isTest" @update="updateScheduleData" />

      <!-- Распределение показов -->
      <DayDistribution :value="localData.lifeTimeDistribution" :title="$t('messages.life_time_distribution_adgroup')"
        :options="lifeTimeOptions" @update="updateLifeTimeDistribution" />

      <!-- (Time of day and day distribution removed) -->
    </div>
  </div>
</template>

<script>
import Currency from './BudgetSchedule/Currency.vue';
import SchedulePeriods from './BudgetSchedule/SchedulePeriods.vue';
import DayDistribution from './BudgetSchedule/DayDistribution.vue';

export default {
  name: "AdGroupBudgetSchedule",
  components: {
    Currency,
    SchedulePeriods,
    DayDistribution
  },
  props: {
      adGroup: {
      type: Object,
      default: () => ({})
    },
    adGroupStart: {
      type: [String, null],
      default: null
    },
    adGroupEnd: {
      type: [String, null],
      default: null
    },
    kpi: {
      type: String,
      default: ''
    },
    priceValue: {
      type: [Number, String],
      default: null
    },
    currencies: {
      type: Array,
      default: () => []
    },
    lockCurrency: {
      type: Boolean,
      default: false
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    isTest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localData: {
        currency: 'KZT',
        paymentValue: 10.00,
        totalBudget: 0.00,
        schedule: [{
          startDate: this.getTodayDate(),
          startTime: '00:00',
          endDate: this.getTodayDate(),
          endTime: '23:59',
          budget: 0.00
        }],
        lifeTimeDistribution: 'evenly'
      },
      lifeTimeOptions: [
        { value: 'evenly', label: this.$t('messages.evenly') },
        { value: 'fast', label: this.$t('messages.fast') }
      ]
    };
  },
  mounted() {
    this.initializeData();
  },
  beforeUnmount() {
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }
  },
  watch: {
    adGroup: {
      handler(newAdGroup) {
        if (newAdGroup) {
          this.initializeData();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    initializeData() {
      if (this.adGroup) {
        const fieldMapping = {
          currency: 'currency',
          paymentValue: 'payment_value',
          totalBudget: 'total_budget',
          lifeTimeDistribution: 'lifetime_distribution',
          schedule: 'schedules'
        };

        Object.keys(fieldMapping).forEach(localKey => {
          const dbKey = fieldMapping[localKey];
          if (this.adGroup[dbKey] !== undefined) {
            if (localKey === 'schedule' && this.adGroup[dbKey]) {
              this.localData[localKey] = this.mapScheduleData(this.adGroup[dbKey]);
            } else {
              this.localData[localKey] = this.adGroup[dbKey];
            }
          }
        });
      }
    },
    mapScheduleData(schedules) {
      if (!schedules || schedules.length === 0) {
        return [{
          startDate: this.getTodayDate(),
          startTime: '00:00',
          endDate: this.getTodayDate(),
          endTime: '23:59',
          budget: 0.00
        }];
      }

      return schedules.map(schedule => ({
        startDate: schedule.start_date ? schedule.start_date.split('T')[0] : this.getTodayDate(),
        startTime: schedule.start_time || '00:00',
        endDate: schedule.end_date ? schedule.end_date.split('T')[0] : this.getTodayDate(),
        endTime: schedule.end_time || '23:59',
        budget: schedule.budget != null ? parseFloat(schedule.budget) : 0,
        planned_volume: schedule.planned_volume != null ? parseInt(schedule.planned_volume, 10) : null
      }));
    },
    getTodayDate() {
      return new Date().toISOString().split('T')[0];
    },
    updateCurrency(currency) {
      this.localData.currency = 'KZT'; // enforce KZT
      this.updateData();
    },
    updateScheduleData(scheduleData) {
      this.localData.schedule = scheduleData.schedule || scheduleData;
      this.updateData();
    },
    updateLifeTimeDistribution(distribution) {
      this.localData.lifeTimeDistribution = distribution;
      this.updateData();
    },
    updateData() {
      if (this.updateTimeout) {
        clearTimeout(this.updateTimeout);
      }
      this.updateTimeout = setTimeout(() => {
        this.$emit('update', this.localData);
      }, 100);
    }
  }
};
</script>

<style lang="scss" scoped>
.budget-schedule {
  max-width: 800px;
}

::deep(.toggle-buttons) {
  display: flex;
  gap: 0;
  background: rgba(245, 245, 245, 1);
  border-radius: 2px;
  padding: 2px;
  border: 0;

  :deep(.toggle-btn) {
    padding: 8px 16px;
    border-radius: 2px;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 14px;

    &:hover {
      background: rgb(245 245 245);
    }

    &.active {
      background: white;
      color: black;
    }
  }
}
</style>
